<template>
    <div class="apa">
        <div class="introduction">
            <div class="introduction__left">
                <h2>APA引用格式快速指南</h2>

                <h3>什么是引用（citations）？</h3>
                <p>
                  引用（citations）是指在学术研究中，您对所使用资料来源的参考与说明。常见形式包括：包括参考文献页内的目录形式，也包括内文引注形式，脚注形式，尾注形式。引用（citations）在您的工作中可以起到一些关键作用，例如说明验证您的研究背景，并为研究人员提供与您研究课题相关的其他资料来源。
                </p>
            </div>
            <div class="introduction__right">
                <img src="https://pstatic.wordvice.com/citation-generator/quick-guide/apa-pub-manual.jpg" alt="APA 7th Publication Manual">
            </div>
        </div>

        <div class="tables-of-contents-container" id="tables-of-contents-container">
            <div class="tables-of-contents on" id="tables-of-contents">
                <b>
                  目录
                </b>
                <ul class="tables-of-contents__list">
                    <li>
                        <a href="#guidelineOverview">APA 引用格式概述</a>
                    </li>
                    <li>
                        <a href="#apaReferences">APA 引用格式基本规则</a>
                    </li>
                    <li>
                        <a href="#formatting">APA 格式的参考文献页规则</a>
                    </li>
                    <li>
                        <a href="#inText">APA 格式的内文引注规则</a>
                    </li>
                    <li>
                        <a href="#changes">APA 第7版的变化</a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- -->
        <div class="block" id="guidelineOverview">
            <h3>APA引用格式概述</h3>
            <p>
              APA（American Psychological Association，美国心理学会）格式是社会科学、行为科学、商业、护理等领域的作者和学生常用的引用格式。
            </p>

            <p>
              本快速指南介绍了《APA出版手册第7版》（2020年）中的重要内容和准则。Wordvice还免费提供APA格式（第6版）、MLA格式（第7版、第8版）、Chicago芝加哥格式（第17版）和Vancouver温哥华格式的使用指南。
            </p>
        </div>

        <!-- -->
        <div class="block" id="apaReferences">
            <h3>APA引用格式规则</h3>
            <p>
              APA格式下的参考文献通常包括作者、出版日期和标题等信息。根据资料来源的类型，参考文献的格式要遵循特定的规则，并可能需要提供有关资料来源的额外信息。
            </p>

            <br>
            <h4>
              基本规则
            </h4>
            <p>
              即使有详细的指导规则，对资料来源的引用对很多作者来说可能仍旧是一项挑战。请查看Wordvice参考文献格式生成器页面上提供的示例，以详细了解每种参考来源的引用格式。
            </p>

            <br>
            <h4>未知信息的格式规则</h4>
            <p>
              在有些情况下，尤其是引用来源于网上信息时，引用所需的信息常常是未知或缺失的。请参考下表，了解如何引用未知来源。
            </p>

            <table class="table">
                <thead>
                <tr>
                    <th>缺失要素</th>
                    <th>解决办法</th>
                    <th>参考文献格式</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>作者</th>
                    <td>参考文献条目使用标题作开头即可。</td>
                    <td>
                      <span class="highlight1">标题</span>. (日期). 来源.<br>
                      <span class="highlight1">Title</span>. (Date). Source.
                    </td>
                </tr>

                <tr>
                    <th>日期</th>
                    <td>采用”n.d.‘’来表达”no date （无日期）”。</td>
                    <td>
                      作者. <span class="highlight1">(n.d.)</span>. 题目. 来源.<br>
                      Author. <span class="highlight1">(n.d.)</span>. Title. Source.
                    </td>
                </tr>

                <tr>
                    <th>题目</th>
                    <td>用方括号来描述引用的信息。</td>
                    <td>
                      作者. (日期). <span class="highlight1">[说明]</span>. 资料来源.<br>
                      Author. (Date). <span class="highlight1">[Description]</span>. Source.
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- -->
        <div class="block" id="formatting">
            <div class="reference-list">
                <div class="reference-list__left">
                    <h3>APA格式的参考文献页规则（Reference Page）</h3>
                    <p>
                      APA格式要求：参考文献页须提供您在论文中引用的所有文献资料的信息。在参考文献页内罗列的引用来源清单中，注意只需将您在文中引用过的文献来源纳入其中即可。
                    </p>

                    <div>
                      APA格式的参考文献页，应遵循以下格式要求：
                      <ul>
                        <li>另起一页，在页面顶部中心位置用粗体标注 <b>"References"。</b></li>
                        <li>按字母顺序依次列出各个参考文献项目。</li>
                        <li>对于每个条目，第一行之后的所有行从左边缘缩进½英寸（"悬挂缩进"）。</li>
                        <li>所有行，包括两个参考文献之间，须采用两倍行距。</li>
                      </ul>
                    </div>
                </div>
                <!-- right -->
                <div class="reference-list__right">
                    <svg class="bi bi-search view-ico" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                    </svg>
                    <a href="https://pstatic.wordvice.com/citation-generator/quick-guide/img_apa_reference_list_cn.png" target="_blank">
                        <img class="lightbox" src="https://pstatic.wordvice.com/citation-generator/quick-guide/img_apa_reference_list_cn.png" alt="Reference List">
                    </a>
                </div>
            </div>

        </div>

        <!-- -->
        <div class="block" id="inText">
            <h3>APA格式的内文引注规则 （In-text Citations）</h3>
            <p>
              内文引注是指在您的文章中的简短引用，以标明对应的信息来源在参考文献列表中的位置。如果您引用（quote/cite/refer）或<a href="https://wordvice.cn/视频-研究论文的改写paraphrasing技巧apa-ama格式/" target="_blank">转述改写（paraphrase）</a> 了别人的工作，您就必须使用内文引注。
            </p>
            <p>
                <a href="https://wordvice.cn/apa格式参考文献写法及英文范例/" target="_blank">APA的内文引注格式</a>遵循“作者-日期法”，由作者的姓氏和出版年份组成。如果您是直接引用或借用一个信息来源，那么需要用缩写 "p/pp"来纳入一个页码。当引用一个信息来源的特定部分时，需要包含时间戳或页码等识别信息。例如：<span class="highlight1">(Harken, 2018, pp. 145-153)</span>.
            </p>

            <br>
            <h4>
              括号夹注和叙述性引用 （Parenthetical and Narrative Citation）
            </h4>
            <p>
              内文引注可以是括号式或叙述式的。括号夹注通常跟在所引用的某一信息来源的内容后面。例如：
            </p>
            <ul>
                <li>
                    In 2010, everything we once knew ... <span class="highlight1">(Kim, 2008)</span>.
                </li>
            </ul>
            <p>
              叙述性引用强调的是所使用的信息来源的作者。例如：
            </p>
            <ul>
                <li>
                    Kim <span class="highlight1">(2008)</span> notes that …
                </li>
            </ul>

            <br>
            <h4>
              其他内文引注规则
            </h4>
            <p>
              虽然APA内文引注的“作者-日期法”相当简单直接，但其具体格式取决于信息来源的类型和作者数量。在作者为三位或三位以上的情况下，在列出第一位作者之后加上 "et al."即可。
            </p>

            <table class="table">
                <thead>
                <tr>
                    <th>类型</th>
                    <th>括号夹注</th>
                    <th>叙述性引用</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>一位作者</th>
                    <td>(<span class="highlight1">Kim</span>, 2020)</td>
                    <td><span class="highlight1">Kim</span> (2020)</td>
                </tr>
                <tr>
                    <th>两位作者</th>
                    <td>(<span class="highlight1">Tshitoyan & Dagdelen</span>, 2019)</td>
                    <td><span class="highlight1">Tshitoyan and Dagdelen</span> (2019)</td>
                </tr>
                <tr>
                    <th>三位或更多作者</th>
                    <td>(Tshitoyan <span class="highlight1">et al.</span>, 2020)</td>
                    <td>Tshitoyan <span class="highlight1">et al.</span> (2020)</td>
                </tr>
                <tr>
                    <th>机构组织</th>
                    <td>(Wordvice, 2020)</td>
                    <td>Wordvice (2020)</td>
                </tr>
                </tbody>
            </table>

            <p>
              当创建内文引注所需的任何信息未知时，请参考下表。
            </p>

            <table class="table">
                <thead>
                <tr>
                    <th>未知要素</th>
                    <th>解决办法</th>
                    <th>内文引注</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>作者</th>
                    <td>提供标题。*</td>
                    <td>
                      (<i class="highlight1">标题</i>, 年份)<br>
                      (<i class="highlight1">Source Title</i>, year)
                    </td>
                </tr>
                <tr>
                    <th>日期</th>
                    <td>采用”n.d.”来表达”no date （无日期）”。</td>
                    <td>
                      (作者, <span class="highlight1">n.d</span>.)<br>
                      (Author, <span class="highlight1">n.d</span>.)
                    </td>
                </tr>
                <tr>
                    <th>标题</th>
                    <td>提供作者和日期。</td>
                    <td>
                      (<span class="highlight1">作者，年份</span>) 或 <span class="highlight1">作者（年份）</span><br>
                      (<span class="highlight1">Author, year</span>) or <span class="highlight1">Author (year)</span>
                    </td>
                </tr>
                </tbody>
            </table>

            <p>
                * 来源标题应根据来源类型，遵循一般的标题大写规则和标题格式。另外，如果参考文献列表中的标题不是斜体，则应放在引号内。
            </p>
        </div> <!-- end inText -->

        <div class="block" id="changes">
            <h3>APA第7版的变化</h3>

            <p>
              APA在2019年秋季更新为第7版。本文列出了第6版和第7版之间的主要区别。
            </p>

            <p>
                <a href="https://apastyle.apa.org/products/publication-manual-7th-edition" target="_blank">APA出版手册第7版</a>包含多处更新。以下就参考文献页和内文引注的格式规则的一些重要变化作简要介绍。
            </p>

            <br>
            <h4>
              参考文献页格式（Reference Page）（APA第7版）
            </h4>

            <ul>
              <li>当有多个作者且作者数不超过20（含20）时，提供所有作者的姓氏及名字/中间名的首字母，并在最后一个作者的姓名前用&连接。对于有21名或更多作者的情况，在第19名和最后一名作者的名字之间使用省略号（...）。</li>
              <li>只有在提供了检索日期时才使用 "Retrieved from"。</li>
              <li>在使用数字对象唯一标识符(DOI)和URLs时，以句号结束引文条目的数据库/档案信息，并提供电子来源的超链接。</li>
            </ul>

            <br>
            <h4>
              内文引注格式 （In-Text Citations ）（APA第7版）
            </h4>

            <ul style="margin-bottom: 0;">
                <li>
                  有三名或三名以上作者的所有来源均使用第一作者的姓名，其后加上“et al.”但是，如果两个来源的第一作者名字相同，则根据需要依次列出作者名字直至可区分论文为止。
                </li>
                <li>
                  引述研究参与者时应采用与一般引述相同的格式，以表明引文来自源文件中的研究参与者。
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "QuickGuideAPA"
}
</script>



// WEBPACK FOOTER //
// src/components/newQuickguide/zh/apa.vue